import request from "../utils/request";

export const getSchedules = '/sys/quartzJob/list'

export function modifySchedule(data: any) {
    return request.request({
        url: '/sys/quartzJob/edit',
        method: 'put',
        data: data
    })
}


export function executeSchedule(jobClassName: string) {
    return request.request({
        url: '/sys/quartzJob/execute',
        method: 'get',
        params: {jobClassName}
    })
}
